import React from "react";

export default function Math_Vectors() {
  return (
    <div>
      <h1>Math_Vectors</h1>
      <p>This is the Math_Vectors component.</p>
    </div>
  );
}
